
export type TransformCallbackFunction = (value?: string|undefined) => string|undefined;


export class XmlDocument {

    xmlDocument: Document;

    constructor(xmlDocument: Document)
    {
        this.xmlDocument = xmlDocument;
    }

    static stringToXmlDocument(xmlString: string) : XmlDocument
    {
        return new XmlDocument((new DOMParser()).parseFromString(xmlString, "text/xml"));
    }

    getNumber(selector: string): number|undefined
    {
        const value = this.xmlDocument.querySelector(selector)?.textContent;
        if (!value || "" === value?.trim())
            return;
        const number = +value;
        if (isNaN(number))
            return;
        return number;
    } 

    // Get a string -- return an empty string if undefined
    getValueString(selector: string, transformFunc?: TransformCallbackFunction): string|undefined {
        const valueStr = this.xmlDocument.querySelector(selector)?.textContent ?? undefined;

        // Transform the value?
        if (undefined !== transformFunc)
            return transformFunc(valueStr);

        return valueStr;
    }

    // Get a string -- if it is only whitespace, return undefined
    getValueString_NonWhitespace(selector: string): string|undefined {
        return this.getValueString(selector, val => {
            const trimStr = val?.trim();
            if ("" === trimStr)
                return;
            return trimStr;
        });
    }


    // Get the XML string for the selected element
    getXmlString(selector: string): string|undefined{
        return this.xmlDocument.querySelector(selector)?.outerHTML;
    }
};